// Visual taxonomy for the reading rail's complementary-color override.
// Mirrors backend/parse/term_families.py. Open string for extensibility:
// new families round-trip through old renderers as inert attribute
// values that fall through to the default cyan palette.
//
// Two-step resolution:
//   1. Explicit `term_family` on the entry wins (set by the reviewer
//      or carried through from the backend's default mapping).
//   2. If absent, derive from `kind` (acronym → specialized,
//      error → scenario, else → null).
//   3. If still null, stamp "foundational" — the default cyan family.
//      Always stamping a non-null value keeps DOM inspection / tests
//      simpler than treating attribute-absence as a meaningful state.

import type { TermKind } from "../data/types";

export const FOUNDATIONAL = "foundational";
export const SPECIALIZED = "specialized";
export const SCENARIO = "scenario";
export const MATH = "math";

export const KNOWN_TERM_FAMILIES: ReadonlyArray<string> = [
  FOUNDATIONAL,
  SPECIALIZED,
  SCENARIO,
  MATH,
];

export const TERM_FAMILY_ATTR = "data-term-family";

export function defaultTermFamilyForKind(
  kind: TermKind | undefined,
): string | null {
  if (kind === "acronym") return SPECIALIZED;
  if (kind === "error") return SCENARIO;
  return null;
}

export interface FamilyResolvable {
  kind?: TermKind;
  term_family?: string | null;
}

export function resolveTermFamily(entry: FamilyResolvable): string {
  return entry.term_family ?? defaultTermFamilyForKind(entry.kind) ?? FOUNDATIONAL;
}
